import React, {useState, useEffect}from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate,useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Modal,Button } from 'react-bootstrap';

function ShipmentEditb2b() {
    let navigate = useNavigate();
    const {slipno} = useParams();
    const [booking_Type, setBooking_Type] = useState('Domestic');
    const [manualAWB, setManualAWB] = useState('');
    const [todaydate, setTodayDate] = useState(getTodayDateString());
    const [currentTime, setCurrentTime] = useState(new Date());
    const [product_Type, setProduct_Type] = useState('Parcel');
    const [billtype, setBilltype] = useState('Cash');
    const [customerlist, setCustomerlist] = useState([]);
    const [selectedcustomer, setSelectedcustomer] = useState([]);
    const [billpayid, setBillpayid] = useState('0');
    const [senderautofilltype, setSenderautofilltype] = useState('');
    const [senderautofilldata, setSenderautofilldata] = useState('');
    const [senderautofilllist, setSenderautofilllist] = useState('');
    const [sendercompanyname, setSendercompanyname] = useState('');
    const [sendercustomername, setSendercustomername] = useState('');
    const [sendermobilenumber, setSendermobilenumber] = useState('');
    const [senderemail, setSenderemail] = useState('');
    const [senderAddress, setSenderAddress] = useState('');
    const [senderPostalcode, setSenderPostalcode] = useState('');
    const [sendercountryname, setSendercountryname] = useState('');
    const [sendercountryid, setSendercountryid] = useState('');
    const [sendercityName, setSendercityName] = useState('');
    const [sendercityId, setSendercityId] = useState('');
    const [sendersaveaddress, setSendersaveaddress] = useState('');
    const [receiverautofilltype, setReceiverautofilltype] = useState('');
    const [receiverautofilldata, setReceiverautofilldata] = useState('');
    const [receiverautofilllist, setReceiverautofilllist] = useState('');
    const [receivercompanyname, setReceivercompanyname] = useState('');
    const [receivercustomername, setReceivercustomername] = useState('');
    const [receivermobilenumber, setReceivermobilenumber] = useState('');
    const [receiveremail, setReceiveremail] = useState('');
    const [receiverAddress, setReceiverAddress] = useState('');
    const [receiverPostalcode, setReceiverPostalcode] = useState('');
    const [receivercountryname, setReceivercountryname] = useState('');
    const [receivercountryid, setReceivercountryid] = useState('');
    const [receivercityName, setReceivercityName] = useState('');
    const [receivercityId, setReceivercityId] = useState('');
    const {headers1,headers2,logout}=AuthUser();
    const [paymenttype, setPaymenttype] = useState('Prepaid');
    const [codprice,setCodprice] = useState('0');
    const [insurance, setInsurance] = useState('No');
    const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const [showSelectBox, setShowSelectBox] = useState(false);
    const [countrylist, setCountrylist] = useState([]);
    const [defaultCountry, setDefaultCountry] = useState('');
    const [defaultCountryid, setDefaultCountryid] = useState('');
    const [senderautoselectcity, setSenderautoselectcity] = useState([]);
    const [receiverautoselectcity, setReceiverautoselectcity] = useState([]);
    const [showSelectBoxcity, setShowSelectBoxcity] = useState(false);
    const [showReceiverSelectBox, setShowReceiverSelectBox] = useState(false);
    const [showreceiverSelectBoxcity, setReceiverShowSelectBoxcity] = useState(false);
    const [showCustomerSelectBox, setShowCustomerSelectBox] = useState(false);
    const [packages, setPackages] = useState([{BoxNumber: "", Height: "", Width: "", Length: "", Weight: ""}]);
    const [servicelist, setServicelist] = useState([]);
    const [selectedservicelist, setSelectedservicelist] = useState('');
    const [setloader, setSetloader] = useState(false);
    const [userdata, setUserdata] = useState('');
    const [agent_id, setAgent_id] = useState('0');
    const [sendercitylist, setSendercitylist] = useState([]);
    const [receivercitylist, setReceivercitylist] = useState([]);
    const [pincodeSenderCity, setPincodeSenderCity] = useState([]);
    const [pincodeReceiverCity, setPincodeReceiverCity] = useState([]);
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [volumetricWeight, setVolumetricWeight] = useState('');
    const [pieces, setPieces] = useState('');
    const [totalAmt, setTotalAmt] = useState('');
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    const [defaultCurrency, setDefaultCurrency] = useState('$');
    const [invoices, setInvoices] = useState([]);
    const [lRNumber, setLRNumber] = useState();
    const [masterSlipNo, setMasterSlipNo] = useState();
    const [orderbags, setOrderbags] = useState([]);
    const [description, setDescription] = useState('');
    const [boxdetails, setBoxdetails] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileOld, setSelectedFileOld] = useState(null);
    const [lR_Type, setLR_Type] = useState('Automatic')
    const [secondaryDocumnet, setSecondaryDocumnet] = useState('')
    const [selectedSecondryFile, setSelectedSecondryFile] = useState(null);
    const [selectedSecondryFileOld, setSelectedSecondryFileOld] = useState(null);
    const [secondar_document_type, setSecondar_document_type] = useState(null);

    useEffect(()=>{
        GetCountrylist();
        GetShipmentdata();
        GetdefaultCountryid();
          const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
         setUserdata(items);
        }
        const timerId = setInterval(() => {
            setCurrentTime(new Date());
        }, 10000);
        return () => clearInterval(timerId);
    },[]);

    const filterBy = (option, state)=> {
        if (state.selected.length) {
          return true;
        }
        return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
      }

    const GetdefaultCountryid=()=>
        {
              axios({
                method: 'post',
                url: Global.baseUrl+'SiteconfigData',
                data: {
                    fliedname: "default_currency"
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setDefaultCurrency(data);
                }
              })
              .catch(function (error) {
                // console.log(error);
                // setLoading(false);
              });
        }

    const GetShipmentdata=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Shipmentdatabyslipnob2b',
            headers:headers1,
            data: {
                slip_no: slipno
            }
          })
          .then(function (response) {
              if(response.data.status == 200)
                {
                    var data=response.data.value;
                GetSenderCityList(data.sendercountry);
                GetReceiverCityList(data.receivercountry);
                setBooking_Type(data.shipment_type);
                setTodayDate(data.entrydate);
                setBillpayid(data.cust_id);
                setAgent_id(data.agent_id);
                setSendercompanyname(data.sender_company_name);
                setBilltype(data.customer_booking_mode)
                setProduct_Type(data.nrd);
                setSendercustomername(data.sender_name);
                setSendermobilenumber(data.sender_phone);
                setSenderemail(data.sender_email);
                setSenderAddress(data.sender_address);
                setSenderPostalcode(data.sender_zip);
                setSendercountryname(data.sendercountry);
                setSendercountryid(data.sendercountryid);
                setSendercityName(data.sendercity);
                setSendercityId(data.sender_city);
                setReceivercompanyname(data.receiver_company_name);
                setReceivercustomername(data.reciever_name);
                setReceivermobilenumber(data.reciever_phone);
                setReceiveremail(data.reciever_email);
                setReceiverAddress(data.reciever_address);
                setReceiverPostalcode(data.reciever_zip);
                setReceivercountryname(data.receivercountry);
                setReceivercountryid(data.receivercountryid);
                setReceivercityName(data.receivercity);
                setReceivercityId(data.reciever_city);
                setPaymenttype(data.booking_mode);
                setCodprice(data.total_cod_amt);
                setPincodeSenderCity([{value: data.sender_city, label:data.sendercity}]);
                setPincodeReceiverCity([{value: data.reciever_city, label:data.receivercity}]);
                setWeight(data.weight);
                setLength(data.length);
                setHeight(data.height);
                setWidth(data.width);
                setVolumetricWeight(data.volumetric_weight);
                setTotalAmt(data.total_amt);
                setLRNumber(data.lr_no);
                setMasterSlipNo(data.master_slip_no);
                setOrderbags(data.order_detail);
                setBoxdetails(data.payment_detail);
                setInvoices(data.invoice_detail);
                setDescription(data.status_describtion);
                setPieces(data.pieces);
                setLR_Type(data.lr_type);
                setSelectedFileOld(data.document);
                setSelectedSecondryFileOld(data.secondry_document);
                setSecondar_document_type(data.secondar_document_type);
                if(data.insurence_charge > 0)
                {
                    setInsurance('Yes');
                }
                else
                {
                    setInsurance('No');
                }
                setPackages(data.product_details)
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
    }

    const handlechange=(e,i)=>{
        const {name,value} = e.target
        const onchangeVal = [...packages]
        onchangeVal[i][name]=value
        setPackages(onchangeVal);
    }

    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
        });
    }

    const GetSenderCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setSendercitylist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const GetReceiverCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setReceivercitylist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const handlesearchcustomertype=(val)=>{
        setSelectedcustomer(val);
        if(val.length >2)
        {
            axios({
                method: 'post',
                url: Global.baseUrl+'Customerdatasearch',
                headers:headers1,
                data: {
                    senderautofilltype: "uniqueid",
                    senderautofilldata: val
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setCustomerlist(response.data.value);
                    setShowCustomerSelectBox(true);

                }
                else
                {
                    setCustomerlist([]);
                    setShowCustomerSelectBox(false);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }
        else
        {
            setShowCustomerSelectBox(false);
        }
    }

    const handelbillbyid=(e)=>{
        const id = e.target.value;
        const name = e.target.options[e.target.selectedIndex].text;
        setSelectedcustomer(name)
        setBillpayid(id);
        setShowCustomerSelectBox(false);
    }
    
    // Function to get today's date in the format "YYYY-MM-DD"
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      const handelsendercountry=(e)=>{
        setSendercountryname(e.target.options[e.target.selectedIndex].text);
        setSendercityName('');
        setSendercityId('');
        setSendercountryid(e.target.value);
      }

      const handelreceivercountry=(e)=>{
        setReceivercountryname(e.target.options[e.target.selectedIndex].text);
        setReceivercityName('');
        setReceivercityId('');
        setReceivercountryid(e.target.value);
      }

      const handelsenderautoselectcity = (selectedOptions) => {
        setPincodeSenderCity(selectedOptions);
        if (selectedOptions.length > 0) {
          const selectedOption = selectedOptions[0];
          setSendercityName(selectedOption.label);
          setSendercityId(selectedOption.value);
        } else {
            setSendercityName('');
          setSendercityId('');
        }
        setServicelist([]);
      };

      const handelReceiverautoselectcity=(e)=>{
        setPincodeReceiverCity(e)
        if (e.length > 0) {
            const id = e[0].value;
            const name = e[0].label;
            setReceivercityName(name);
            setReceivercityId(id);
        }
        else
        {
            setReceivercityName('');
            setReceivercityId('');
        }
        setServicelist([]);
      }

       const handelservice=()=>{
        if(lR_Type =="Manual" && lRNumber =="")
        {
            toast.warn('Please enter manual AWB No.');
            return;
        }
        if(sendercustomername =="")
        {
            toast.warn('Please enter sender customer name');
            return;
        }
        if(sendermobilenumber =="")
        {
            toast.warn('Please enter sender customer mobile number');
            return;
        }
        if(senderAddress =="")
        {
            toast.warn('Please enter sender customer address');
            return;
        }
        if(sendercountryname =="")
        {
            toast.warn('Please select sender country');
            return;
        }
        if(sendercityName =="")
        {
            toast.warn('Please select sender city');
            return;
        }
        if(receivercustomername =="")
        {
            toast.warn('Please enter receiver customer name');
            return;
        }
        if(receivermobilenumber =="")
        {
            toast.warn('Please enter receiver customer mobile number');
            return;
        }
        if(receiverAddress =="")
        {
            toast.warn('Please enter receiver customer address');
            return;
        }
        if(receivercountryname =="")
        {
            toast.warn('Please Select receiver country');
            return;
        }
        if(receivercityName =="")
        {
            toast.warn('Please select receiver city');
            return;
        }
        if(description =="")
        {
            toast.warn('Please enter description');
            return;
        }
        for (let i = 0; i < invoices.length; i++) 
            {
                const invoiceno = invoices[i];
    
                if(!invoiceno.invioce_no) // || isNaN(invoiceno.InvoiceNumber)
                {
                    toast.warn('Please enter invoice number');
                    return;
                }
                if(!invoiceno.amount  || isNaN(invoiceno.amount))
                {
                    toast.warn('Please enter amount');
                    return;
                }
            }
        // if (!selectedFileOld && !selectedFile) {
        //     toast.error('No file selected. Please select file');
        //     return;
        // } 
        
        axios({
            method: 'post',
            url: Global.baseUrl+'showservice',
            headers:headers1,
            data: {
                sendercountryid: sendercountryid,
                sendercityId : sendercityId,
                senderpincode : senderPostalcode,
                receivercountryid: receivercountryid,
                receivercityId: receivercityId,
                receiverpincode: receiverPostalcode,
                products: packages,
                height: height,
                width: width,
                length: length,
                weight: weight,
                booking_Type: booking_Type,
                product_Type: product_Type,
                cust_id:billpayid,
                insurance:insurance,
                paymenttype:paymenttype,
                codprice:codprice,
                type:userdata.usertype,
                agent_id:0,
                type:'B2B'

            }
        })
        .then(function (response) {
            if(response.data.status == 200)
            {
                setServicelist(response.data.value);
                setShowModal(true); // Open the modal using state
            }
            else
            {
                toast.warn(response.data.message);
                setServicelist([]);
            }
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
        }

      const handleClose = () => {
        setServicelist([]);
        setShowModal(false); // Close modal handler
      }

      const handelactiveservice=(index)=>{
             const newList= servicelist[index];
             setSelectedservicelist(newList);
      }
      const UpddateShipment=()=>{
        if(sendercustomername =="")
        {
            toast.warn('Please Enter Sender Customer Name');
        }
        else if(sendermobilenumber =="")
        {
            toast.warn('Please Enter Sender Customer Mobile Number');
        }
        else if(senderAddress =="")
        {
            toast.warn('Please Enter Sender Customer Address');
        }
        else if(sendercountryname =="")
        {
            toast.warn('Please Select Sender Country');
        }
        else if(sendercityName =="")
        {
            toast.warn('Please Select Sender City');
        }
        else if(receivercustomername =="")
        {
            toast.warn('Please Enter Receiver Customer Name');
        }
        else if(receivermobilenumber =="")
        {
            toast.warn('Please Enter Receiver Customer Mobile Number');
        }
        else if(receiverAddress =="")
        {
            toast.warn('Please Enter Receiver Customer Address');
        }
        else if(receivercountryname =="")
        {
            toast.warn('Please Select Receiver Country');
        }
        else if(receivercityName =="")
        {
            toast.warn('Please Select Receiver city');
        }
        else
        {
            setSetloader(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'UpddateShipmentb2b',
                headers:headers2,
                data: {
                    slipno: slipno,
                    booking_Type: booking_Type,
                    manualAWB:manualAWB,
                    todaydate:todaydate,
                    currentTime:formattedTime,
                    product_Type: product_Type,
                    billtype:billtype,
                    sendercompanyname:sendercompanyname,
                    sendercustomername:sendercustomername,
                    sendermobilenumber:sendermobilenumber,
                    senderemail:senderemail,
                    senderAddress:senderAddress,
                    senderPostalcode:senderPostalcode,
                    sendercityId : sendercityId,
                    sendercountryid:sendercountryid,
                    receivercompanyname:receivercompanyname,
                    receivercustomername:receivercustomername,
                    receivermobilenumber:receivermobilenumber,
                    receiveremail:receiveremail,
                    receiverAddress:receiverAddress,
                    receiverPostalcode:receiverPostalcode,
                    receivercityId: receivercityId,
                    receivercountryid:receivercountryid,
                    productsdetails: packages,
                    height: height,
                    width: width,
                    length: length,
                    weight: weight,
                    paymenttype:paymenttype,
                    codprice:codprice,
                    insurance:insurance,
                    servicedetails:selectedservicelist,
                    cust_id:billpayid,
                    type:userdata.usertype,
                    agent_id:0,
                    user_id:userdata.id,
                    hub_id:0,
                    orderDetails: orderbags,
                    invoiceDetails: invoices,
                    document: selectedFile,
                    documentold: selectedFileOld,
                    description:description,
                    lR_Type:lR_Type,
                    lRNumber:lRNumber,
                    selectedSecondryFileold:selectedSecondryFileOld,
                    secondaryDocumnet:secondaryDocumnet,
                    selectedSecondryFile:selectedSecondryFile,

                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setSetloader(false);
                    setTimeout(() => {
                        navigate('/Shipmentlistb2b/All');
                      }, 1000);
                }
                else
                {
                    toast.warn(response.data.message);
                    setSetloader(false);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }
      }

      const handleInvoiceschange = (nameOrEvent, valueOrIndex, iOptional) => {
            setServicelist([]);

            // Case 1: Called with name, value, index
            if (typeof nameOrEvent === 'string') {
                const name = nameOrEvent;
                const value = valueOrIndex;
                const i = iOptional;

                const updated = [...invoices];
                updated[i][name] = value;
                setInvoices(updated);
                return;
            }

            // Case 2: Normal event usage (for invoice_no, amount)
            const e = nameOrEvent;
            const i = valueOrIndex;
            const { name, value } = e.target;

            const updated = [...invoices];
            updated[i][name] = value;
            setInvoices(updated);
            };


        const handleorderchange=(e,i)=>{
            setServicelist([]);
            const {name,value} = e.target
            const onchangeVal = [...orderbags]
            onchangeVal[i][name]=value
            setOrderbags(onchangeVal);
        }
        const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setSelectedFile(selectedFile);
        }
      };

      const handleFileChangeSecondary = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setSelectedSecondryFile(selectedFile);
        }
      };

      const handelSecondaryDocumnet=(e)=>{
        setSecondaryDocumnet(e);
    }

    const handleRemoveFiles = () => {
    setSelectedFile(null);
    setSelectedFileOld(null);
    };

    const handleRemovesecondryFiles = () => {
    setSelectedSecondryFileOld(null);
    setSelectedSecondryFile(null);
    };

    const handlechangepackage = (e, packageIndex) => {
        const { name, value } = e.target;
    
        setPackages((prev) => 
            prev.map((pkg, i) => 
                i === packageIndex ? { ...pkg, [name]: value } : pkg
            )
        );
    };


    return (
        <>
            <LeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer/>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="/Admin-Dash">
                                        <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">All Shipments</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" type="button" onClick={()=>navigate(-1)}>
                                    <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Edit Shipment</h2>
                            </div>
                        </div>
                    </div>

                    <div className="btn-toolbar mb-2 mb-md-0">
                    </div>
                </div>

                <section>
                    <div className="row">
                        <div className="col-12 col-md-9">
                            <section className="mb-4">
                                <h5>LR Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                        <div className="col-12 col-md-12 mb-3">
                                                <div>
                                                    <p>
                                                    <strong className="form-check-label" for="Domestic">LR Number:</strong>
                                                    <span> {lRNumber}</span>
                                                    </p>
                                                    <p>
                                                    <strong className="form-check-label" for="Domestic">Master AWB Number:</strong>
                                                    <span> {masterSlipNo}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section className="mb-4">
                                <div className="row">
                                    <div className="col-12 col-md">
                                        <h5>Add Senders Details</h5>
                                        <div className="card">
                                            <div className="card-body">
                                                {/* <div className="d-flex justify-content-between mb-4">
                                                    <small className="text-muted">Where is the order being sent from?</small>
                                                    <div className="text-end">
                                                        <small><a data-bs-toggle="collapse" data-bs-target="#autofill" className="text-primary">Use Auto Fill<i className="bx bx-chevron-down"></i></a></small>
                                                    </div>
                                                </div> */}

                                                <div className="row ">
                                                    {/* <div className="col-12 col-md-12 mb-3 collapse" id="autofill">
                                                        <label for="email" className="form-label">Auto Fill details using:</label>
                                                        <div className="input-group select_account">
                                                            <select className="form-select" style={{"width": "20px !important"}} onChange={(e)=>setSenderautofilltype(e.target.value)}>
                                                                <option value=''>--Please Select--</option>
                                                                <option value='uniqueid'>Account Number</option>
                                                                <option value='phone'>Mobile</option>
                                                                <option value='address'>Address UID</option>
                                                            </select>
                                                            <input type="text" className="form-control" placeholder="Enter details to fetch data" value={senderautofilldata} onChange={(e)=>handlesendersearchdata(e.target.value)} />
                                                            
                                                        </div>
                                                        {showSelectBox &&
                                                            <select className="form-select" size="5" onChange={(e)=>handlesenderdata(e.target.value)}>
                                                                {senderautofilllist.map((al,i)=>{
                                                                return(
                                                                <option value={al.uniqueid} className="searchtypehead">{al.name} {al.uniqueid}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            }
                                                    </div> */}
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Company Name:</label>
                                                        <input type="text" className="form-control" value={sendercompanyname} placeholder="Enter Company Name" onChange={(e)=>setSendercompanyname(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Full Customer Name <span className="text-danger">*</span> :</label>
                                                        <input type="text" className="form-control" value={sendercustomername} placeholder="Enter Customer Name" onChange={(e)=>setSendercustomername(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">Mobile Number <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={sendermobilenumber} placeholder="Enter Mobile Number" onChange={(e)=>setSendermobilenumber(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">Email ID:</label>
                                                        <input type="text" className="form-control" value={senderemail} placeholder="Enter email address" onChange={(e)=>setSenderemail(e.target.value)}/>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Complete Address <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={senderAddress} placeholder="Enter full address" onChange={(e)=>setSenderAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Pin/Postal/Zip code:</label>
                                                        <input type="text" className="form-control" value={senderPostalcode} placeholder="Enter pincode" onChange={(e)=>setSenderPostalcode(e.target.value)} disabled/>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">Country <span className="text-danger">*</span>:</label>
                                                        <select className="form-select" onChange={handelsendercountry} disabled>
                                                            <option value="">--Please Select--</option>
                                                            {countrylist.map((cl,i)=>{
                                                                return(
                                                                    <option value={cl.id} selected={sendercountryid == cl.id} key={i}>{cl.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">City <span className="text-danger">*</span>:</label>
                                                        <Typeahead
                                                            filterBy={filterBy}
                                                            id="toggle-example"
                                                            options={sendercitylist}
                                                            placeholder="Choose a city..."
                                                            onChange={handelsenderautoselectcity}
                                                            selected={pincodeSenderCity}
                                                            disabled
                                                        />
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md">
                                        <h5>Add Receiver Details</h5>
                                        <div className="card">
                                            <div className="card-body">
                                                {/* <div className="d-flex justify-content-between mb-4">
                                                    <small className="text-muted">Where is the order being sent from?</small>
                                                    <div className="text-end">
                                                        <small><a data-bs-toggle="collapse" data-bs-target="#recautofill" className="text-primary">Use Auto Fill<i className="bx bx-chevron-down"></i></a></small>
                                                    </div>
                                                </div> */}

                                                <div className="row ">
                                                    {/* <div className="col-12 col-md-12 mb-3 collapse" id="recautofill">
                                                        <label for="email" className="form-label">Auto Fill details using:</label>
                                                        <div className="input-group select_account">
                                                            <select className="form-select" style={{"width": "20px !important"}} onChange={(e)=>setReceiverautofilltype(e.target.value)}>
                                                                <option value=''>--Please Select--</option>
                                                                <option value='uniqueid'>Account Number</option>
                                                                <option value='phone'>Mobile</option>
                                                                <option value='address'>Address UID</option>
                                                            </select>
                                                            <input type="text" className="form-control" placeholder="Enter details to fetch data" value={receiverautofilldata} onChange={(e)=>handlereceiversearchdata(e.target.value)} />
                                                            
                                                        </div>
                                                        {showReceiverSelectBox &&
                                                            <select className="form-select" size="5" onChange={(e)=>handleReceiverdata(e.target.value)}>
                                                                {receiverautofilllist.map((al,i)=>{
                                                                return(
                                                                <option value={al.uniqueid} className="searchtypehead">{al.name} {al.uniqueid}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            }
                                                    </div> */}
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Company Name:</label>
                                                        <input type="text" className="form-control" value={receivercompanyname} placeholder="Enter Company Name" onChange={(e)=>setReceivercompanyname(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Full Customer Name <span className="text-danger">*</span> :</label>
                                                        <input type="text" className="form-control" value={receivercustomername} placeholder="Enter Customer Name" onChange={(e)=>setReceivercustomername(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">Mobile Number <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={receivermobilenumber} placeholder="Enter Mobile Number" onChange={(e)=>setReceivermobilenumber(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">Email ID:</label>
                                                        <input type="text" className="form-control" value={receiveremail} placeholder="Enter email address" onChange={(e)=>setReceiveremail(e.target.value)}/>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Complete Address <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={receiverAddress} placeholder="Enter full address" onChange={(e)=>setReceiverAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label for="email" className="form-label">Pin/Postal/Zip code:</label>
                                                        <input type="text" className="form-control" value={receiverPostalcode} placeholder="Enter pincode" onChange={(e)=>setReceiverPostalcode(e.target.value)} disabled/>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">Country <span className="text-danger">*</span>:</label>
                                                        <select className="form-select" onChange={handelreceivercountry} disabled>
                                                            <option value="">--Please Select--</option>
                                                            {countrylist.map((cl,i)=>{
                                                                return(
                                                                    <option value={cl.id} selected={receivercountryid == cl.id} key={i}>{cl.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label for="email" className="form-label">City <span className="text-danger">*</span>:</label>
                                                        <Typeahead
                                                            filterBy={filterBy}
                                                            id="toggle-example"
                                                            options={receivercitylist}
                                                            placeholder="Choose a city..."
                                                            onChange={handelReceiverautoselectcity}
                                                            selected={pincodeReceiverCity}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                             <section className="mb-4">
                                <h5>Order Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-md-12 mb-3">
                                                    <label className="form-label">Description <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="Description" placeholder="Enter order description" value={description} onChange={(e)=>setDescription(e.target.value)} />
                                                </div>
                                            </div>
                                            {orderbags.map((val, i) => (
                                            <div className="row" key={i}>
                                                <div className="col-12 col-md-5 mb-3">
                                                    <label className="form-label">Your reference ID / order ID <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="orderid" disabled placeholder="Enter your reference ID / order ID" value={val.order_no} onChange={(e)=>handleorderchange(e,i)} />
                                                </div>
                                                <div className="col-12 col-md-5 mb-3">
                                                    <label className="form-label">No. of boxes <span className="text-danger">*</span>:</label>
                                                    <input type="number" className="form-control" name="no_boxes" disabled placeholder="Enter no. of boxes" value={val.no_of_boxes} onChange={(e)=>handleorderchange(e,i)} />
                                                </div>
                                            </div>
                                            ))}
                                </div>
                                </div>
                            </section>
                             <section className="mb-4">
                                <h5>Invoice Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                    <h6>Payment Details</h6>
                                    <small>Select mode of payment that your buyer has chosen for the order</small>
                                    <div className="row mt-3">
                                            <div className="col-12 col-md-2">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="inlineRadiod20" checked={paymenttype == 'Prepaid'} onChange={()=>setPaymenttype('Prepaid')} />
                                                    <label className="form-check-label" for="inlineRadiod20">Prepaid </label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="inlineRadiod21" checked={paymenttype == 'COD'} onChange={()=>setPaymenttype('COD')} />
                                                    <label className="form-check-label" for="inlineRadiod21">Cash On Delivery </label>
                                                </div>
                                            </div>
                                            {paymenttype =='COD' &&
                                            <div className="col-12 col-md-4">
                                                {/* <input type="text" className="form-control" placeholder="Enter COD Amount" onChange={(e)=>handlecodamount(Number(e.target.value))} /> */}
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    value={codprice} 
                                                    onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    const totalAmount = packages.reduce((sum, product) => sum + (parseFloat(product.ProductPrice) * parseInt(product.ProductQTY)), 0);
                                                    setCodprice(value > totalAmount ? 0 : value);
                                                }} 
                                                disabled
                                                />
                                            </div>
                                            }
                                        </div>
                                        <hr/>
                                            {invoices.map((val, i) => (
                                            <div className="row" key={i}>
                                                <div className="col-12 col-md-4 mb-3">
                                                    <label className="form-label">E-Way Bill Number<span className="text-danger"></span>:</label>
                                                    <input
                                                        type="text"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        maxLength="12"
                                                        className="form-control"
                                                        name="eway_bill_no"
                                                        placeholder="Enter your reference ID / order ID"
                                                        value={val.eway_bill_no}
                                                        onChange={(e) => {
                                                            const onlyNums = e.target.value.replace(/\D/g, '');
                                                            handleInvoiceschange('eway_bill_no', onlyNums, i);
                                                        }}
                                                        onPaste={(e) => {
                                                            const pasted = e.clipboardData.getData('text');
                                                            if (/\D/.test(pasted)) e.preventDefault(); // Block if pasted text contains non-numbers
                                                        }}
                                                        onDrop={(e) => {
                                                            e.preventDefault(); // Block drag-drop
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
                                                            ];
                                                            if (
                                                            !/^\d$/.test(e.key) &&
                                                            !allowedKeys.includes(e.key)
                                                            ) {
                                                            e.preventDefault();
                                                            }
                                                        }}
                                                        
                                                        />

                                                </div>
                                                <div className="col-12 col-md-3 mb-3">
                                                    <label className="form-label">Invoice Number <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="invioce_no" placeholder="Enter invoice number" value={val.invioce_no} onChange={(e)=>handleInvoiceschange(e,i)} />
                                                </div>
                                                <div className="col-12 col-md-3 mb-3">
                                                    <label className="form-label">Amount <span className="text-danger">*</span>:</label>
                                                    <input type="number" className="form-control" name="amount" placeholder="Enter no. of boxes" value={val.amount} onChange={(e)=>handleInvoiceschange(e,i)} />
                                                </div>
                                            </div>
                                            ))}
                                        {/* <input type="checkbox" name="ewaybillon" checked={isChecked} onChange={handleChange}/> I will add E-Way Bill later/ E-Way Bill not required for this shipment */}
                                        <hr/>
                                        <h6>Insurance</h6>
                                        <small>Select the insurance mode for the shipment</small>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md-2">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="or" value="option2" checked={insurance == 'No'} onChange={()=>setInsurance('No')} />
                                                    <label className="form-check-label" for="or">OR <a href="#" title="Owner Risk"><i className="bx bx-help-circle"></i></a></label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="cr" checked={insurance == 'Yes'} onChange={()=>setInsurance('Yes')} />
                                                    <label className="form-check-label" for="cr">CR <a href="#" title="Carrier Risk"><i className="bx bx-help-circle"></i></a></label>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </div>
                            </section>

                        </div>
                        <div className="col-12 col-md sticky-bottom">
                            <section className="mb-4">
                                <h5>Weights & Dimensions</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            {packages.map((box,packageIndex) => (
                                                <div key={`package-${packageIndex}`} className="card bg-gray-100">
                                                <div className="card-body">
                                                    <h5>Package {packageIndex + 1}</h5>
                                                    <div className="row">
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">
                                                        Number of boxes
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="BoxNumber"
                                                            placeholder="0"
                                                            value={box.BoxNumber}
                                                            onChange={(e) => handlechangepackage(e, packageIndex)}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                            <label className="form-label">
                                                                Height (CM)
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name="Height"
                                                                placeholder="0"
                                                                value={box.Height}
                                                                onChange={(e) => handlechangepackage(e, packageIndex)}
                                                            />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                            <label className="form-label">
                                                                Width (CM)
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name="Width"
                                                                placeholder="0"
                                                                value={box.Width}
                                                                onChange={(e) => handlechangepackage(e, packageIndex)}
                                                            />
                                                    </div>
                                                        <div className="col-12 col-md-6 mb-3">
                                                                <label className="form-label">
                                                                    Length (CM)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    name="Length"
                                                                    placeholder="0"
                                                                    value={box.Length}
                                                                    onChange={(e) => handlechangepackage(e, packageIndex)}
                                                                />
                                                        </div>
                                                        <div className="col-12 col-md-6 mb-3">
                                                                <label className="form-label">
                                                                    Weight (KG)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    name="Weight"
                                                                    placeholder="0"
                                                                    value={box.Weight}
                                                                    onChange={(e) => handlechangepackage(e, packageIndex)}
                                                                />
                                                                
                                                        </div>
                                                        {/* <div className="col-12 col-md-3 mb-3">
                                                            <span className="input-group-text">KG</span>
                                                        </div> */}
                                                        <div className="mt-4">
                                                        
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>

                                            // <div className="col-12 col-md-12" key={i}>
                                            //      <div class="bg-light rounded p-3 text-muted mb-3 select-text">
                                            //         <p class="fw-semibold mb-1 select-text">{box.no_box} Boxes</p>
                                            //         <p class="mb-0 select-text">{box.height} x {box.width} x {box.length} cms</p>
                                            //     </div>
                                            // </div>
                                            ))}
                                            {/* <div class="col-12 col-md-12 mt-2">
                                                <div class="d-flex justify-content-between mb-1">
                                                <strong>Total charged weight</strong>
                                                <span>{volumetricWeight} Kgs</span>
                                                </div>
                                                <div class="d-flex justify-content-between mb-1">
                                                <strong>Total no.of boxes</strong>
                                                <span>{pieces}</span>
                                                </div>
                                                <div class="d-flex justify-content-between mb-1">
                                                <strong>Freight amount</strong>
                                                <span>{defaultCurrency}{totalAmt}</span>
                                                </div>
                                            </div> */}
                                        </div>                
                                    </div>
                                </div>
                            </section>
                            <section className="mb-4">
                                <h5>Upload Documents</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <h6>Upload Documents</h6>
                                        <small>Max size 20MB</small>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md bulk_import fileinput">
                                                {selectedFileOld || selectedFile ? (
                                                    <div style={styles.previewContainer}>
                                                    <div style={styles.iconContainer}>
                                                        <img
                                                        src="https://img.icons8.com/ios-filled/50/document.png"
                                                        alt="icon"
                                                        style={styles.icon}
                                                        />
                                                    </div>
                                                    <div style={styles.filename}>
                                                        {selectedFileOld ? selectedFileOld : selectedFile.name}
                                                    </div>
                                                    <span style={styles.apicon} onClick={handleRemoveFiles}>X</span>
                                                    </div>
                                                ) : (
                                                    <div className="card fileupload">
                                                    <div className="card-body">
                                                        <label className="custom-file-upload">
                                                        <input
                                                            type="file"
                                                            onChange={(e)=>setSelectedFile(e.target.files[0])}
                                                            accept=".png,.jpg,.jpeg,.pdf,.bmp"
                                                        />
                                                        <i className="fa fa-cloud-upload"></i> Browse and Upload
                                                        </label>
                                                        <p>Upload Document (PNG, JPG, JPEG, PDF)</p>
                                                    </div>
                                                    </div>
                                                )}
                                                </div>

                                        </div>
                                       <h6 className="mt-3">Secondary Document (Optional)</h6>
                                       <select name="" className="form-control" onChange={(e)=>handelSecondaryDocumnet(e.target.value)}>
                                        <option value="">Select Document Type</option>
                                        <option value="Ewaybill-Form" selected={secondar_document_type =='Ewaybill-Form'}>Ewaybill Form</option>
                                        <option value="Goods-Declaration" selected={secondar_document_type =='Goods-Declaration'}>Goods Declaration</option>
                                        <option value="Delivery-Challan" selected={secondar_document_type =='Delivery-Challan'}>Delivery Challan</option>
                                        <option value="PO-Copy" selected={secondar_document_type =='PO-Copy'}>PO Copy</option>
                                        <option value="KYC" selected={secondar_document_type =='KYC'}>KYC</option>
                                        <option value="Regulatory-Form" selected={secondar_document_type =='Regulatory-Form'}>Regulatory Form</option>
                                        <option value="Photo-ID" selected={secondar_document_type =='Photo-ID'}>Photo ID</option>
                                        <option value="ASN" selected={secondar_document_type =='ASN'}>ASN</option>
                                        <option value="Einvoice-QR" selected={secondar_document_type =='Einvoice-QR'}>Einvoice QR</option>
                                       </select>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md bulk_import fileinput">
                                                {selectedSecondryFileOld || selectedSecondryFile ? (
                                                        <div style={styles.previewContainer}>
                                                        <div style={styles.iconContainer}>
                                                            <img
                                                            src="https://img.icons8.com/ios-filled/50/document.png"
                                                            alt="icon"
                                                            style={styles.icon}
                                                            />
                                                        </div>
                                                        <div style={styles.filename}>{selectedSecondryFileOld ? selectedSecondryFileOld : selectedSecondryFile.name}</div>
                                                        <span style={styles.apicon} onClick={handleRemovesecondryFiles}>X</span>
                                                        </div>
                                                    ):(
                                                    <div className="card fileupload">
                                                        <div className="card-body">
                                                            <label className="custom-file-upload">
                                                                <input type="file" onChange={(e)=>setSelectedSecondryFile(e.target.files[0])} accept=".png,.jpg,.jpeg,.pdf,.bmp" />
                                                                <i className="fa fa-cloud-upload"></i> Browse and Upload
                                                            </label>
                                                            <p>Upload Document (PNG, JPG, JPEG, PDF)</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {servicelist != undefined && servicelist.length > 0 ?
                                ''
                            :
                                <div className="text-center">
                                    <button type="button" className="btn btn-primary btn-lg btn-block center" onClick={()=>handelservice()}>Show service</button>
                                </div>    
                            }
                        </div>
        </div >
            </section >
            {/* Modal */}
            <Modal size="lg" show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Service Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 col-md">
                            <div className="row">
                                <div className={`col-12 ${selectedservicelist !== undefined && selectedservicelist.totalprice ? 'col-md-6': 'col-md-12'} mb-3`}>
                                    <section className="sele_service mb-4">
                                        <h5>Choose shipping service</h5>
                                        {servicelist != undefined && servicelist.length > 0 ?
                                        <>
                                        {servicelist.map((ser,i)=>{
                                            const hasTotalPrice = ser.totalprice && ser.totalprice !== null && ser.totalprice !== '0.00';
                                            return(
                                            hasTotalPrice && (
                                            <div className="list-group mb-3" key={i}>
                                                <button type="button" className={`list-group-item list-group-item-action ${selectedservicelist.unique_id == ser.unique_id ?'active':''}`} onClick={()=>handelactiveservice(i)}>
                                                    <div className="text-center">
                                                        <h2><small>{defaultCurrency}</small>{ser.totalprice}</h2>
                                                        <h6>{ser.services_name}</h6>
                                                        <h6>Estimated Delivery {ser.days} Days</h6>
                                                    </div>
                                                </button>
                                            </div>
                                            )
                                            );
                                            })}
                                            </>
                                        :
                                            <div className="list-group">
                                                <a href="#" className="list-group-item list-group-item-action bg-danger">
                                                    <div className="text-center text-white">
                                                        <h2 className=""><i className="bx bx-error"></i></h2>
                                                        <h6>No service available for the selected locations</h6>
                                                    </div>
                                                </a>
                                            </div>
                                        }
                                    </section>
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    {selectedservicelist !=undefined && selectedservicelist.totalprice &&
                                    <section className="cost_brake mb-4">
                                        <h6 className="">Shipping Cost Breakup</h6>
                                        <div className="card">
                                            <div className="card-body">
                                                <table className="table">
                                                    <tbody>
                                                        {selectedservicelist !=undefined && selectedservicelist.service_charge > 0 &&
                                                        <tr>
                                                            <td>Freight Cost</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.service_charge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.totalFuelsurchage > 0 &&
                                                        <tr>
                                                            <td>Fuel Surcharge</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.totalFuelsurchage}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.custom_clearence > 0 &&
                                                        <tr>
                                                            <td>Custom Clearance</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.custom_clearence}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.codCharge > 0 &&
                                                        <tr>
                                                            <td>COD</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.codCharge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.insurance_chagre > 0 &&
                                                        <tr>
                                                            <td>Insurance</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.insurance_chagre}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.esscharge > 0 &&
                                                        <tr>
                                                            <td>ESS Surcharge</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.esscharge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.elevated_risk_charge > 0 &&
                                                        <tr>
                                                            <td>Elevated Risk</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.elevated_risk_charge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.restricted_destination > 0 &&
                                                        <tr>
                                                            <td>Restricted Destination</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.restricted_destination}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.remoterareadelivery > 0 &&
                                                        <tr>
                                                            <td>Remote Area Delivery</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.remoterareadelivery}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.service_tax_val > 0 &&
                                                        <tr>
                                                            <td>GST - {selectedservicelist !=undefined && selectedservicelist.service_tax}%</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.service_tax_val}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.vat_tax_val > 0 &&
                                                        <tr>
                                                            <td>VAT - {selectedservicelist !=undefined && selectedservicelist.vat_tax}%</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.vat_tax_val}</td>
                                                        </tr>
                                                        }
                                                        <tr>
                                                            <td>Total</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.totalprice}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                    }
                                </div>
                                {selectedservicelist !='' && (
                                            setloader == false ? (
                                            <div>
                                                <div className="d-grid">
                                                    <button type="button" className="btn btn-primary btn-lg btn-block " onClick={()=>UpddateShipment()}>Update Shipment </button>
                                                </div>
                                            </div>
                                            ):(
                                            <div>
                                                <div className="d-grid">
                                                    <button type="button" className="btn btn-primary btn-lg btn-block " onClick={()=>UpddateShipment()}>Update Shipment </button>
                                                </div>
                                                <div className="d-grid">
                                                    <a href="" className="btn btn-primary btn-lg btn-block disabled"> <span className="spinner"></span></a>
                                                </div>
                                            </div>
                                            )
                                    ) }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        <Footer />
            </main >
        </>
    )
}
const styles = {
  previewContainer: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #eee',
    borderRadius: '8px',
    padding: '8px 12px',
    maxWidth: '300px',
    marginTop: '12px',
    backgroundColor: '#fafafa'
  },
  iconContainer: {
    marginRight: '10px'
  },
  icon: {
    width: '24px',
    height: '24px'
  },
  filename: {
    fontSize: '14px',
    color: '#333'
  },
  apicon: {
    border: '1px solid',
    borderRadius: '15px',
    width: '20px',
    margin: '0px auto',
    paddingRight:'0.5rem',
    paddingLeft: '0.3rem',
    cursor: 'pointer'
}
};
export default ShipmentEditb2b;